import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '../views/index.vue'
import index2 from '../views/index2.vue'
import evaluation from "../views/evaluation.vue"
import result from "../views/result.vue"
import record from "../views/record.vue"
import end from "../views/scene/end.vue"

import bookHotel from './bookHotel'
import BuyTrainTickets from './BuyTrainTickets'
import voiceCall from './voiceCall'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'indexPage',
    component: index
  },
  {
    path: '/index2',
    name: 'index2Page',
    component: index2
  },
  {
    path: '/evaluation',
    name: 'evaluationPage',
    component: evaluation
  },
  {
    path: '/result',
    name: 'resultPage',
    component: result
  },
  {
    path: '/record',
    name: 'recordPage',
    component: record
  },
  {
    path: '/end',
    name: 'endPage',
    component: end
  },
bookHotel,
BuyTrainTickets,
voiceCall
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
